import { createAction, props } from '@ngrx/store';
import { INSAutoCompleteGroup, INSAutoCompleteOption } from '@norfolk-southern/accessns-components';

import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import { IThirdPartyEcrData, IThirdPartyEcrEquipmentTypes, IThirdPartyLineOfBusiness } from '@ruby/modules/third-party/models/third-party.interface';
import { IStation, IStationDetail } from '@ruby/shared/models/commons/station.interface';
import { IStcc } from '@ruby/shared/models/rate-inquiry/stcc.interface';
import { IError } from '@ruby/shared/models/request/error.interface';

export const loadAvailableLineOfBusiness = createAction(
  '[Third Party Auth] Load Available Line Of Business',
  props<{ companyEId: string; tplCompanyEId: string; afterSign?: boolean }>()
);

export const loadAvailableLineOfBusinessSuccess = createAction(
  '[Third Party Auth] Load Available Line Of Business Success',
  props<{ data: Array<IThirdPartyLineOfBusiness>; afterSign?: boolean }>()
);

export const loadAvailableLineOfBusinessFailure = createAction(
  '[Third Party Auth] Load Available Line Of Business Failure',
  props<{ error: IError }>()
);

export const setSelectedLocations = createAction(
  '[Third Party Auth] set Selected Locations',
  props<{ data: { type: string; customer: ICustomer } }>()
);

export const loadEquipmentTypes = createAction(
  '[Third Party Auth] Load Equipment Types'
);

export const loadEquipmentTypesSuccess = createAction(
  '[Third Party Auth] Load Equipment Types Success',
  props<{ data: Array<IThirdPartyEcrEquipmentTypes> }>()
);

export const loadEquipmentTypesFailure = createAction(
  '[Third Party Auth] Load Equipment Types Failure',
  props<{ error: IError }>()
);

export const loadStates = createAction(
  '[Third Party Auth] Load States'
);

export const loadStatesSuccess = createAction(
  '[Third Party Auth] Load States Success',
  props<{ data: Array<INSAutoCompleteGroup> }>()
);

export const loadStatesFailure = createAction(
  '[Third Party Auth] Load States Failure',
  props<{ error: IError }>()
);

export const loadDestinationStations = createAction(
  '[Third Party Auth] Load Destination Stations',
  props<{ data: IStation }>()
);

export const loadDestinationStationsSuccess = createAction(
  '[Third Party Auth] Load Destination Stations Success',
  props<{ data: Array<IStationDetail> }>()
);

export const loadDestinationStationsFailure = createAction(
  '[Third Party Auth] Load Destination Stations Failure',
  props<{ error: IError }>()
);

export const setDestinationStations = createAction(
  '[Third Party Auth] Set Destination Stations',
  props<{ data: Array<IStationDetail> }>()
);

export const loadStcc = createAction(
  '[Third Party Auth] Load STCC',
  props<{ data: IStcc }>()
);

export const loadStccSuccess = createAction(
  '[Third Party Auth] Load STCC Success',
  props<{ data: Array<INSAutoCompleteOption> }>()
);

export const loadStccFailure = createAction(
  '[Third Party Auth] Load STCC Failure',
  props<{ error: IError }>()
);

export const setStcc = createAction(
  '[Third Party Auth] Set STCC',
  props<{ data: Array<INSAutoCompleteOption> }>()
);

export const loadScac = createAction(
  '[Third Party Auth] Load SCAC',
  props<{ data: string }>()
);

export const loadScacSuccess = createAction(
  '[Third Party Auth] Load SCAC Success',
  props<{ data: Array<INSAutoCompleteOption> }>()
);

export const loadScacFailure = createAction(
  '[Third Party Auth] Load SCAC Failure',
  props<{ error: IError }>()
);

export const setEcrData = createAction(
  '[Third Party Auth] Set Empty Car Request Data',
  props<{ data: IThirdPartyEcrData }>()
);

export const setSelectedLOB = createAction(
  '[Third Party Auth] Set Selected LOB',
  props<{ data: string }>()
);

export const setTransportation = createAction(
  '[Third Party Auth] Set Transportation',
  props<{ data: boolean }>()
);

export const setEcr = createAction(
  '[Third Party Auth] Set Empty Car Request',
  props<{ data: boolean }>()
);

export const setRating = createAction(
  '[Third Party Auth] Set Rating',
  props<{ data: boolean }>()
);

export const setHljs = createAction(
  '[Third Party Auth] Set HLJS',
  props<{ data: boolean }>()
);

export const setRevenue = createAction(
  '[Third Party Auth] Set Revenue',
  props<{ data: boolean }>()
);

export const setRevenueClaims = createAction(
  '[Third Party Auth] Set Revenue Claims',
  props<{ data: boolean }>()
);

export const setStorageAndLift = createAction(
  '[Third Party Auth] Set Storage And Lift',
  props<{ data: boolean }>()
);

export const clear = createAction(
  '[Third Party Auth] Clear'
);

export const setAuthorizationStatus = createAction(
  '[Third Party Auth] Set Authorization Status',
  props<{ data: boolean }>()
);

export const setLineOfBusiness = createAction(
  '[Third Party Auth] Set Line Of Business',
  props<{ data: IThirdPartyLineOfBusiness }>()
);

export const clearApplications = createAction(
  '[Third Party Auth] Clear Applications'
);
